"use client";

import { motion } from "framer-motion";
import { ReactNode } from "react";

type Direction = "top" | "bottom" | "left" | "right" | "none";

interface MotionFadeInProps {
  children: ReactNode;
  direction?: Direction;
  delay?: number;
  duration?: number;
  className?: string;
}

export function MotionFadeIn({
  children,
  direction = "bottom",
  delay = 0,
  duration = 0.5,
  className,
}: MotionFadeInProps) {
  const variants = {
    hidden: {
      opacity: 0,
      x: direction === "left" ? -40 : direction === "right" ? 40 : 0,
      y: direction === "top" ? -40 : direction === "bottom" ? 40 : 0,
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
    },
  };

  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ delay, duration, ease: "easeOut" }}
      variants={variants}
    >
      {children}
    </motion.div>
  );
}